enum EReviewsTypes {
  Dailyrent = 'Dailyrent',
}

export const DailyrentConfig = {
  /** Показывать ли мелкий текст под h1-заголовком страницы */
  SHOW_HEADER_SUMMARY: false,
  /** Показывать ли блок с плюсами/минусами */
  SHOW_MASTER_REVIEW: false,
  /** Показывать ли контролы сортировки */
  SHOW_SORTING: false,
  /** Показывать ли блок с кнопками 'написать отзыв' и 'задать вопрос' */
  SHOW_REVIEW_CONTROLS: false,
  /** Показывать ли блок с лайком/дизлайком */
  SHOW_LIKE_BUTTONS: false,
  /** Показывать ли кнопку и модалку ответа на отзыв */
  SHOW_ANSWER_BUTTON: false,
  /** Показывать ли таба выбора типа отзыва (отзывы/вопросы) */
  SHOW_REVIEWS_TABS: false,
  /** Показывать ли модалку создания отзыва */
  SHOW_NEW_REVIEWS_MODAL: false,
  /** Показывать ли модалку создания вопроса */
  SHOW_NEW_QUESTION_MODAL: false,
  /** Показывать ли ответы на отзывы всегда */
  ALWAYS_SHOW_ANSWERS_UNDER_REVIEW: true,
  /** Можно ли отвечать на ответы */
  CAN_USER_ANSWER_ON_ANSWER: false,
};

export const ReviewsConfig = {
  [EReviewsTypes.Dailyrent]: DailyrentConfig,
};

/**
 * Возвращает конфиг для управления отображением блоков на странице.
 * Самая первая предварительная версия решения, в будущем следует вынести в хук или формировать и хранить конфиг в config.custom страницы.
 * Плюс нужно будет пересмотреть названия ключей конфига, чтобы они точно отражали суть
 * @param reviewsType
 */
export const getReviewsConfig = (reviewsType = EReviewsTypes.Dailyrent) => {
  return ReviewsConfig[reviewsType];
};
